import MainModal from '@/common/components/base/modal/Modal.tsx';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import { relatedFilesQueryOption } from '@/common/queries/relatedFiles/relatedFilesQueryOption.ts';
import { Center } from 'styled-system/jsx';
import CircularLoading from '@/common/components/base/Loading/CircularLoading.tsx';
import { AcceptFileModalSelectorType } from '@/modules/FileList/components/modals/acceptFileModals/AcceptFileModals.type.ts';
import HasRelatedFileAcceptModal from '@/modules/FileList/components/modals/acceptFileModals/HasRelatedFileAcceptModal.tsx';
import NotRelatedAcceptFileModal from '@/modules/FileList/components/modals/acceptFileModals/NotRelatedAcceptFileModal.tsx';

export default ({ closeModal, open, fileId }: AcceptFileModalSelectorType) => {
  return (
    <MainModal open={open} closeModal={closeModal}>
      <AcceptFileModalSelector closeModal={closeModal} fileId={fileId} />
    </MainModal>
  );
};

const AcceptFileModalSelector = ({
  fileId,
  closeModal,
}: Omit<AcceptFileModalSelectorType, 'open'>) => {
  const queryClient = useQueryClient();
  const { isPending, data } = useQuery(relatedFilesQueryOption({ id: fileId }));
  const acceptFile = () => {
    queryClient.invalidateQueries({ queryKey: ['my-files'] });
    closeModal();
  };
  return (
    <>
      {isPending ? (
        <Center height="350px">
          <CircularLoading color={'colors.purple-primary'} />
        </Center>
      ) : data?.relatedFiles.length ? (
        <HasRelatedFileAcceptModal fileId={fileId} closeModal={acceptFile} />
      ) : (
        <NotRelatedAcceptFileModal fileId={fileId} closeModal={acceptFile} />
      )}
    </>
  );
};
